// extracted by mini-css-extract-plugin
export var pagination = "Pagination-module--pagination--16ouy";
export var older = "Pagination-module--older--3OpP2";
export var newer = "Pagination-module--newer--2v_X3";
export var small = "Pagination-module--small--19XAa";
export var large = "Pagination-module--large--1qu__";